
import "./privacy.css";

import { useState} from "react";

const PrivacyDriverApp = () => {
  const [isActive, setIsActive] = useState("#privacy_policy_driver");
  
  const toggleClass = (e:any) => {
    setIsActive(e.currentTarget.hash);
  };


  const entries:any = performance.getEntriesByType("navigation");
  entries.forEach((entry:any) => {
  if (entry.type === "reload") {
    window.location.href = '/privacy-driverapp';
  }
});

  return (
    <div className="wrapper">
      <div className="container">
        <div id="wbars_all">
          <div className="atl_container atl_base_container">
            <div id="wbars">
              <div className="atl_content legal_pp">
                <div className="atl_header">
                  <h1 id="privacy_policy_driver">
                    <strong>Privacy Policy of AES Driver Application</strong>
                  </h1>
                   <p>
                    Atlas Energy Solutions (“Atlas,” “we,” “our”) built the AES Driver Application (the “App”) as a commercial application to provide drivers with a convenient portal for receiving job and route information. To enable the App and provide the best services, Atlas collects and uses some “Personal Data” from users of the App (“Users” or “you”). “Personal Data” is any information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular consumer or device, such as a User’s name, phone number, email address and, in certain circumstances, a User’s location and route information or other data which can be reasonably linked to such information by Atlas.
                  </p>
                  <br />
                  <p>
                    This Privacy Policy is meant to help Users understand what information Atlas collects, why Atlas collects it, and how Users can update, manage, and delete their information. Different Users may be subject to different protection standards, and broader standards may therefore apply to some than apply to others. In order to learn more about the protection criteria, Users can refer to the applicability section. 
                  </p>
                  <br />
                  <p>
                    If you have any questions about this Privacy Policy, or if you believe that your privacy has been compromised in the course of using the App, please contact Atlas by email at <a href="mailto:privacy@atlas.energy"><strong>privacy@atlas.energy</strong></a>, or by postal mail at:
                  </p>

                  <p className="pt-15">
                  <strong>Atlas Energy Solutions </strong>
                  </p>
                  <p className="pt-15">ATTN : <strong>VP Technology</strong></p>
                  <p className="pt-15">5918 W Courtyard Dr Suite 500,</p>
                  <p>Austin, TX 78730, United States
                  </p>
                  
                </div>
                
                <div className="one_line_col">
                  <h2 id="types_of_data" className="pb-10">Types of Data collected</h2>

                  <p>
                    Atlas may collect a variety of Personal Data about you in a number of ways:
                  </p>

                  <ul>
                  <li>
                  <strong>Personal Data you provide directly.</strong> Data collected by us that you provide directly may include your email address, phone number, first name, last name, precise location permission (continuous), approximate location permission (continuous) and motion sensors permission.
                  </li>
                  <li>
                    
                    <strong>Information Atlas collects as you use the App.</strong> collects certain information about your activity in the App, which we use to provide you with the services of the App. In particular, location and route information and movement activity is collected in the form of GPS signals combined with time-stamps, as well as other information from sensors and receivers on or around your device on which the App is installed and activated.
                    
                    </li>
                  </ul>

                  

                  <h3
                    className="atl-subheading atl-subheading-legal-mode-processing"
                  >
                  Additional information regarding the Personal Data captured
                  </h3>
                  <p>
                    If a User desires not to provide his or her first or last name, a pseudonym can be used. An email address or mobile number is required for the purpose of authentication/OTP verification only.
                  </p>
                  <p>
                    Users who are uncertain about which Personal Data is mandatory are welcome to contact Atlas at the contact information listed above.
                  </p>
                  
                </div>

                

                <div className="one_line_col">
                  <h2 id="device_permissions" className="pb-10">
                    Device permissions for Personal Data access
                  </h2>
                  
                  <p>
                    Depending on the User’s specific device, the App may request certain permissions that allow it to access the User’s device data as described below. By default, these permissions must be granted by the User before the respective information can be accessed. Once the permission has been given, it can be revoked by the User at any time. In order to revoke these permissions, Users may refer to the device settings or contact Atlas for support at the contact details provided above. The exact procedure for controlling app permissions may be dependent on the User’s specific device and software. Please note that the revocation of such permissions might impact the proper functioning of the App. 
                  </p>
                  <p>
                    If the User grants any of the permissions listed below, the resultant Personal Data may be processed (i.e., accessed, modified or removed) by Atlas. 
                  </p>

                  <ul>
                    <li>
                    <strong>Approximate location permission (continuous).</strong> Approximate location permission is used for accessing the approximate location of the User’s device.
                    </li>
                    <li>
                      
                      <strong>Precise location permission (continuous).</strong> Precise location permission is used for accessing the precise location of the User’s device
                      
                      </li>
                      <li>
                        <strong>Motion sensors permission.</strong> Motion sensors permission is used for accessing the motion sensors of the User’s device to determine movement direction.
                      </li>
                    </ul>

                  <p>The App may collect and use a User’s approximate location, precise location and motion sensor data in order to provide the User with location-based services like navigation and route recommendations and to provide Atlas with delivery status information.</p>
                  
                </div>

                <div data-locale="en"></div>

                <div className="one_line_col">
                  <h2 id="purpose_of_data_collection">
                    Purposes of data collection
                  </h2>
                  <p className="pt-15">
                    Atlas may use information collected from or provided by you for the following purposes:
                  </p>

                  <ul>
                    <li>
                    <strong>To provide App services.</strong> Atlas uses your location and route information to provide navigation services to you as you make your deliveries, and to obtain delivery status information for use by Atlas. Any use of tracking tools by Atlas or the App serves the purpose of providing the services required by the User.
                    </li>
                    <li>
                      
                      <strong>To maintain and improve Atlas’s Services.</strong> Atlas also uses your information to ensure the App services are working as intended, such as troubleshooting issues you report to Atlas. 
                      
                      </li>
                      <li>
                        <strong>To communicate with Users.</strong> Atlas may use your information to send you updates, notices, delivery requests and additional information related to the services of the App (including through push notifications or email messages). In addition, if you contact Atlas, Atlas may keep a record of your request or communication in order to help resolve any issues you might be facing.
                      </li>
                      <li>
                        <strong>To protect Atlas, its Users and for legal reasons.</strong> Atlas may also use and process your information for the following purposes:
                        <ul className="li-sub"><li>for the purposes of or to enforce the App’s Terms of Use or Privacy Policy;</li>
                        <li>to contact you when Atlas believes it to be necessary;</li>
                        <li>to comply with any applicable law and assist law enforcement agencies under any applicable law, when Atlas has a good faith belief that Atlas’s cooperation with such law enforcement agencies is legally mandated or meets the applicable legal standards and procedures;</li>
                      <li>to detect abuse and illegal activity;</li>
                    <li>to detect and prevent fraud, misappropriation, infringements, identity theft and other illegal activities and misuse of the App;</li>
                  <li>to take any action in any case of dispute, or legal proceeding of any kind between you and the App or third parties with respect to, or in connection with the App or the services provided by the App;</li>
                <li>to help improve the safety and reliability of the services provided by the App, including detecting, preventing, and responding to security or safety risks and technical issues that could harm Atlas, the Users or the public;</li>
              <li>to create aggregated and/or anonymous data (where such data does not enable the identification of a specific user).</li>
            </ul>
                      </li>
                    
                    </ul>

              <p>Atlas will ask for your consent before using your information for a purpose that isn’t covered in this Privacy Policy.</p>


                  
                </div>

                <div data-locale="en"></div>

                <div className="one_line_col">
                  <h2 id="service_providers">
                    Service Providers
                  </h2>
                 <p>
                  We may use third-party partners to help us operate and maintain our App and deliver our services. Third-party service providers are contractually restricted in their use or disclosure of information, except as necessary to perform services on our behalf or to comply with legal requirements.
                 </p>
                  <p>By registering or authenticating an App account, each User permits Atlas to identify the User and may provide Atlas with authority to share their Personal Data with dedicated services like hosting and storage. Hosting and storage services serve the purpose of hosting data and files that enable the App to run and be distributed as well as to provide a ready-made infrastructure to run specific features or parts of the App.  </p>
                  
                </div>

                <div className="one_line_col">
                  <h2 id="data_retention">
                    Data Retention and deletion
                  </h2>
                  <p className="pt-15">
                    Some data you can delete whenever you like, some data is deleted automatically, and some data Atlas retains for longer periods of time when necessary. This section describes why Atlas retains different types of data for different periods of time.
                  </p>

                  <ul>
                    <li>
                    <strong>Information retained until you remove it.</strong> Some Personal Data, such as your name, phone number, email address and other App account-related information, will be retained by Atlas in your App account until you choose to remove it and/or update it.
                    </li>
                    <li>
                      
                      <strong>Data that expires after a specific period of time.</strong> In some cases, you don’t need to actively delete your information, because Atlas sets retention timeframes based on the reason for the data’s collection. Atlas may also take steps to anonymize certain data within set time periods.
                      
                      </li>
                      <li>
                        <strong>Information retained until your App account is deleted.</strong> Atlas may keep some data for the life of your App account if it is useful for helping Atlas understand how Users interact with features of the App and how Atlas can improve its services. For example, if you make an incident report, Atlas will keep information about how many reports you have submitted, even after the event is removed.
                      </li>
                      <li>
                        <strong>Information retained for extended time periods for limited purposes.</strong> In certain circumstances, business and legal requirements may oblige Atlas to retain certain information, for specific purposes, for an extended period of time. Reasons Atlas might retain some data for extended periods of time include:
                        <ul className="li-sub"><li>security, fraud and abuse prevention,</li>
                        <li>financial record-keeping,</li>
                        <li>complying with legal or regulatory requirements,</li>
                      <li>ensuring the continuity of Atlas’s services, and</li>
                    <li>direct communications with Atlas.</li>
                  
            </ul>
                      </li>
                    
                    </ul>
                    <p>
                      Users may request deletion of their account at any time by submitting a request to <a href="mailto:privacy@atlas.energy"><strong>privacy@atlas.energy</strong></a>. Following an account deletion request, Atlas deletes the User’s account and data, unless they must be retained due to legal or regulatory requirements, for purposes of safety, security, and fraud prevention, or because of an issue relating to the User’s account such as an outstanding credit or an unresolved claim or dispute. For inquiries relating to changing or deleting your account or Personal Data, you or an authorized agent can contact us at <a href="mailto:privacy@atlas.energy"><strong>privacy@atlas.energy</strong></a>.
                    </p>

                </div>

                <div className="one_line_col">
                  <h2 id="mergers_acquisitions">
                    Mergers, Acquisitions and Other Business Transactions
                  </h2>
                  
                  <p>
                    We may decide to sell, buy or otherwise reorganize our business. These types of transactions may involve the disclosure of personal information to prospective or actual purchasers, or receiving it from sellers. We seek appropriate protection for Personal Data in these types of transactions.
                  </p>
                  
              
                </div>

      
                <div className="one_line_col">
                  <h2 id="changes_to_privacy" className="pb-10">Changes to this Privacy Policy</h2>

                  <p>
                    We may need to change, modify and/or update this Privacy Policy from time to time and we reserve the right to do so without prior notice and at any time. If we do make changes in the way Personal Data is used or managed, any updates will be posted here, so you should also revisit this Privacy Policy periodically. Your continued use of the App following the posting of any such changes will automatically be deemed your acceptance of all changes.
                  </p>

                  <div className="atl_footer">
                    <p>Latest update: March 31, 2023</p>
                    
                    
                  </div>
                  
                </div>


                
               

                
              </div>
             
            </div>
            
          </div>
         
        </div>
      </div>
      <div className="sidebar">
        <ul id="alllinks_driverapp">
          <li>
            <a href="#privacy_policy_driver" className={isActive == '#privacy_policy_driver' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Privacy Policy of AES Driver Application
              </span>
            </a>
          </li>
          
          <li>
            <a href="#types_of_data" className={isActive == '#types_of_data' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">Types of Data collected </span>
            </a>
          </li>
          
          <li>
            <a href="#device_permissions" className={isActive == '#device_permissions' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Device permissions for Personal Data access
              </span>
            </a>
          </li>
          <li>
            <a href="#purpose_of_data_collection" className={isActive == '#purpose_of_data_collection' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">Purposes of data collection</span>
            </a>
          </li>

          
          <li>
            <a href="#service_providers" className={isActive == '#service_providers' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Service Providers
              </span>
            </a>
          </li>

          <li>
            <a href="#data_retention" className={isActive == '#data_retention' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">Data Retention and deletion</span>
            </a>
          </li>

          <li>
            <a href="#mergers_acquisitions" className={isActive == '#mergers_acquisitions' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Mergers, Acquisitions and Other Business Transactions
              </span>
            </a>
          </li>

          <li>
            <a href="#changes_to_privacy" className={isActive == '#changes_to_privacy' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Changes to this Privacy Policy
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default PrivacyDriverApp;
